// @flow
import { ExperiencesActionTypes } from './constants';

type ExperiencesAction = { type: string, payload: {} | string };

// common success
export const experiencesApiResponseSuccess = (actionType: string, data: any): ExperiencesAction => ({
    type: ExperiencesActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const experiencesApiResponseError = (actionType: string, error: string): ExperiencesAction => ({
    type: ExperiencesActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getExperience = (id: string): ExperiencesAction => ({
    type: ExperiencesActionTypes.GET_EXPERIENCE,
    payload: { id },
});

export const addExperience = (experience: any): ExperiencesAction => ({
    type: ExperiencesActionTypes.ADD_EXPERIENCE,
    payload: experience
})
export const updateExperience = (experience: any): ExperiencesAction => ({
    type: ExperiencesActionTypes.UPDATE_EXPERIENCE,
    payload: experience
})
export const deleteExperience = (id: string): ExperiencesAction => ({
    type: ExperiencesActionTypes.DELETE_EXPERIENCE,
    payload: { id }
})

export const listExperiences = (params: any): ExperiencesAction => ({
    type: ExperiencesActionTypes.LIST_EXPERIENCES,
    payload: params,
});

export const setFiltersExperiences = (params: any): ExperiencesAction => ({
    type: ExperiencesActionTypes.SET_FILTER,
    payload: params,
});


export const resetExperiences = (): ExperiencesAction => ({
    type: ExperiencesActionTypes.RESET,
    payload: {},
});

